module.exports = __webpack_public_path__ + "img/JAOC_POP_SquidInkSauce_round.d3911a24.png";